import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import cx from 'classnames';
import { ContentImage, DateInfo } from 'govbr.frontend.policy/components';
import PropTypes from 'prop-types';

import styles from './WithImagesTemplate.module.less';

// TODO: Testar tamanhos das fontes em celular real
// TODO: Usar srcset

const WithImagesTemplate = ({
  items,
  linkTitle,
  linkHref,
  isEditMode,
  hideImage = false,
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <div>
        <ul className="listing-style-none pl-0">
          {items.map((item) => {
            const {
              '@id': url,
              id,
              title,
              description,
              review_state,
              alt,
            } = item;
            const imageField = [
              'preview_image',
              'preview_image_link',
              'image',
            ].find((field) => item.image_scales?.[field]?.length);
            return (
              <li className="listing-style-none" key={item['@id']}>
                <ConditionalLink
                  item={item}
                  condition={!isEditMode}
                  className="br-item"
                  key={url}
                >
                  <div className="py-3 d-flex align-items-center" key={url}>
                    <div className="flex-fill">
                      <div
                        className={cx(
                          'text-base text-sm-up-02 text-weight-medium text-interactive',
                          { [`review-state-${review_state}`]: review_state },
                        )}
                      >
                        {title ? title : id}
                      </div>
                      <div className="mb-2 text-down-01 text-sm-up-01 text-gray-80">
                        {description}
                      </div>
                      <DateInfo
                        item={item}
                        className="text-down-01 text-sm-base"
                      />
                    </div>
                    {!hideImage && (
                      <ContentImage
                        item={item}
                        alt={alt || description}
                        customField={imageField}
                        size="mini"
                        className={styles.thumb}
                      />
                    )}
                  </div>
                </ConditionalLink>
              </li>
            );
          })}
        </ul>
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

WithImagesTemplate.propTypes = {
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default WithImagesTemplate;
